exports.SignedRecord = require('./signed_record');
